import React, { useEffect, useState } from "react";
import { CollapsibleSectionHeading } from "../../molecules/CustomCollapse";
import { useMount } from "react-use";
import AppProvider, { CDN_domain } from "../../../api/appProvider";
import Thumbnail from "../../molecules/Thumbnail";
import {
  visualizationsActions,
  visViewModes,
  useVisualizationState,
  useDispatchVisualization
} from "../../../reducers/visualizations.reducer";
import { useDebouncedCallback } from "use-debounce/lib";
import { Collapse } from "@blueprintjs/core";
import strings from "../../../strings";
import { useMyroomState } from "../../../reducers/myroom.reducer";

import { getExtension } from "../../../utils/utils";
import { getPathOffile } from "../../../utils/arrayUtils";
import ReactGA from "react-ga";
import DesignTopViewThumb from "../../molecules/DesignTopViewThumb";
import {
  entryViews,
  mainUiActions,
  pageViews,
  useUiDispatch,
  useUiState
} from "../../../reducers/mainui.reducer";
import { useDesignListState } from "../../../reducers/designlist.reducer";
import AtCheckbox from "../../atoms/AtCheckbox";
const myroomThumbUrl = CDN_domain + "v3assets/myroom/My-Room-Thumb.svg";
const RoomList = props => {
  const { scrollIntoView } = props;
  const dispatchUiState = useUiDispatch();

  const { visualizations } = window.flags;

  const { initRoomPath, initShotName } = window.initialData;

  const visualizationState = useVisualizationState();
  const designState = useDesignListState();
  const uiState = useUiState();
  const myroomState = useMyroomState();
  const dispatch = useDispatchVisualization();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState([]);
  const showAllRooms = window.flags.visualizations.showAllRoomFiles;
  const [roomViewChanged, setRoomViewChanged] = useState(false);
  const pageView = window.flags.homeTemplate;
  useMount(() => {
    const handleFetchRooms = async () => {
      const rooms = await AppProvider.fetchRoomList({});
      const roomsControl = window.flags.roomsControl || [];
      var filteredRoomsFolder;
      const isStudioTemplate = sessionStorage.getItem("entryview") == entryViews.STUDIO;
      if (isStudioTemplate) {
        filteredRoomsFolder = rooms.filter(
          item => item.Type === "folder" && item.FullPath !== "Rooms"
        );

        dispatch({ type: visualizationsActions.SET_ROOM_FOLDERS, payload: filteredRoomsFolder });
      }
      if (roomsControl.length) {
        dispatch({ type: visualizationsActions.SET_ROOMS_CONTROL, payload: roomsControl });
      }
      var filteredRooms;
      if (showAllRooms) {
        filteredRooms = rooms.filter(
          item => item.Type === "file" && getExtension(item.FullPath) === "crf3d"
        );
      } else {
        filteredRooms = rooms.filter(
          item =>
            item.Type === "file" &&
            getExtension(item.FullPath) === "crf3d" &&
            getPathOffile(item.FullPath) === "/Rooms"
        );
      }
      if (!filteredRooms.length) return;

      dispatch({
        type: visualizationsActions.SET_ILLUSTRATIONS,
        payload: filteredRooms.map(item => ({ ...item, label: item.Name }))
      });

      var roomsWithThumbs;
      if (isStudioTemplate) {
        // if (window.flags.entryTemplate === entryViews.STUDIO) {
        roomsWithThumbs = filteredRooms;
      } else {
        roomsWithThumbs = await AppProvider.getRoomThumbnails({ rooms: filteredRooms });
      }

      dispatch({ type: visualizationsActions.SET_ILLUSTRATIONS, payload: roomsWithThumbs });

      let ind = 0;
      const views = ["foldedbackview", "perspectiveview", "myroom"];
      if (initRoomPath && views.indexOf(initRoomPath.toLowerCase()) !== -1) return;
      if (initRoomPath && initRoomPath !== "") {
        ind = roomsWithThumbs.findIndex(
          item => item.FullPath.toLowerCase() === initRoomPath.toLowerCase()
        );
        if (ind < 0) {
          dispatchUiState({
            type: mainUiActions.SET_TOAST_PROPS,
            payload: {
              message: strings.toastMessages.triggeredRoomNotFound,
              intent: "warning",
              timeout: 7000
            }
          });
          ind = 0;
        }
      }
      if (initShotName) {
        dispatch({
          type: visualizationsActions.SET_ACTIVE_NODE,
          payload: { shot: initShotName, ...roomsWithThumbs[ind] }
        });
      } else if (isStudioTemplate) {
        var initRoomFolderIndex = 0;
        var initRoomFileIndex = 0;
        if (initRoomPath && initRoomPath !== "") {
          const initRoomFolder = initRoomPath.toLowerCase().split("/")[1];

          const initRoom = initRoomPath.toLowerCase().split("/")[2];
          initRoomFolderIndex = filteredRoomsFolder.findIndex(
            item => item.Name.toLowerCase() == initRoomFolder.toLowerCase()
          );
          initRoomFileIndex = filteredRoomsFolder[initRoomFolderIndex].files.findIndex(item =>
            item.toLowerCase().includes(initRoom.toLowerCase())
          );
        }
        if (filteredRoomsFolder.length) {
          const index = roomsWithThumbs.findIndex(
            obj =>
              obj.FullPath === filteredRoomsFolder[initRoomFolderIndex].files[initRoomFileIndex]
          );
          dispatch({
            type: visualizationsActions.SET_ACTIVE_NODE,
            payload: roomsWithThumbs[index]
          });

          dispatch({
            type: visualizationsActions.SET_SIMILAR_ROOMS,
            payload: filteredRoomsFolder[initRoomFolderIndex].files
          });
        } else {
          const index = roomsWithThumbs.findIndex(
            obj => obj.FullPath === filteredRooms[initRoomFileIndex].FullPath
          );

          dispatch({
            type: visualizationsActions.SET_ACTIVE_NODE,
            payload: roomsWithThumbs[index]
          });
        }
      } else {
        dispatch({
          type: visualizationsActions.SET_ACTIVE_NODE,
          payload: roomsWithThumbs[ind]
        });
      }
    };
    handleFetchRooms();
  });

  const [debouncedThumbnailClick] = useDebouncedCallback((node, e) => {
    handleThumbnailClick(node, e);
  }, 400);
  const handleThumbnailClick = node => {
    {
      window.flags.homeTemplate === pageViews.CREATEYOURRUG &&
        scrollIntoView(".cyr-roomViewContainer");
    }
    if (node) {
      ReactGA.ga("send", "event", {
        eventCategory: "View", //required
        eventAction: "Clicked Room Thumbnail", //required
        eventLabel: `Clicked on ${node.FullPath}`
      });
    }

    // AppAnalytics.sendDesignDetails({ roomPath: node.FullPath }).then(status => {
    //   //console.log("AppAnalytics.sendDesignDetails ~ status", status);
    // });
    dispatch({ type: visualizationsActions.SET_ACTIVE_NODE, payload: node });
    dispatch({ type: visualizationsActions.SET_VIEW_MODE, payload: visViewModes.ROOM_VIEW });
  };
  const handleLoadMyRoom = (node, e) => {
    ReactGA.ga("send", "event", {
      eventCategory: "View", //required
      eventAction: "Clicked My Room", //required
      eventLabel: "Clicked on My Room"
    });
    // AppAnalytics.sendDesignDetails({ roomPath: "Myroom" })
    //   .then(status => {
    //     //console.log("AppAnalytics.sendDesignDetails ~ status", status);
    //   })
    //   .catch(error => {
    //     console.log(" AppAnalytics: send my room clicked Details ~ error", error);
    //   });
    dispatch({ type: visualizationsActions.SET_VIEW_MODE, payload: visViewModes.MY_ROOM });
  };
  const handleMyRoomThumbnailClick = node => {
    dispatch({ type: visualizationsActions.SET_ACTIVE_NODE, payload: node });
    dispatch({ type: visualizationsActions.SET_VIEW_MODE, payload: visViewModes.ROOM_VIEW });
  };
  const getRoomName = item => {
    var roomName = item.label;
    if (!window.flags.language.translateNames) return roomName;
    if (strings.names && strings.names.hasOwnProperty(roomName.toUpperCase())) {
      roomName = strings.names[roomName.toUpperCase()] || roomName;
    }
    return roomName;
  };

  const handleThumbnailSelected = (name, isChecked) => {
    if (isChecked) {
      setRoomViewChanged(true);
      setSelectedRoom(prev => [...prev, name]); // Add item to the array
    } else {
      setSelectedRoom(prev => prev.filter(item => item !== name)); // Remove item
    }
  };

  const filteredSelectedRoom = visualizationState.illustrations.filter(room =>
    selectedRoom.includes(room.Name)
  );

  useEffect(() => {
    dispatch({ type: visualizationsActions.SET_SELECTEDROOMS, payload: filteredSelectedRoom });
    if (filteredSelectedRoom.length) {
      dispatch({ type: visualizationsActions.SET_ACTIVE_NODE, payload: filteredSelectedRoom[0] });
      dispatch({ type: visualizationsActions.SET_VIEW_MODE, payload: visViewModes.ROOM_VIEW });
    }
  }, [selectedRoom]);

  return (
    <>
      <CollapsibleSectionHeading
        title={strings.visualization.illustrationViews}
        isOpen={!isCollapsed}
        handleCollapseIconClick={() => setIsCollapsed(!isCollapsed)}
        handleHeadingClick={() => setIsCollapsed(!isCollapsed)}
      />
      <div className="at-section-container at-vis-thumbs">
        <Collapse isOpen={!isCollapsed}>
          <div className="thumb-container">
            {visualizations.keepPerspectiveViewInRoomlist && (
              <Thumbnail
                className="at-perspective-thumb"
                datatitle="perspective"
                thumb={{
                  thumbUrl: designState.selectedFile.thumbUrl,
                  name: "Interactive view"
                }}
                aspect="landscape"
                onThumbnailClick={() => {
                  const element = document.querySelector(`.thumb-title[title="Perspective View"]`);
                  if (element) {
                    element.click();
                  }
                }}
              />
            )}
            {visualizations.keepDesignTopViewInRoomlist && <DesignTopViewThumb />}
            {visualizationState.illustrations.map((item, i) => (
              <div>
                {window.flags.interface.showInhouseTools?.showCreateCombination && (
                  <AtCheckbox
                    checked={selectedRoom.includes(getRoomName(item))}
                    onChange={e => {
                      handleThumbnailSelected(getRoomName(item), e.target.checked);
                    }}
                  />
                )}

                <Thumbnail
                  thumbType="ROOM_THUMBS"
                  datatitle={getRoomName(item)}
                  active={
                    window.flags.homeTemplate === pageViews.BRAND
                      ? visualizationState.activeNode.id === item.id
                      : visualizationState.activeNode.id === item.id &&
                        visualizationState.viewMode === visViewModes.ROOM_VIEW
                  }
                  thumb={{ ...item, name: getRoomName(item), thumbUrl: item.Thumb }}
                  aspect="landscape"
                  key={i}
                  onThumbnailClick={e => debouncedThumbnailClick(item, e)}
                />
              </div>
            ))}
            {visualizations.myRoomEnabled &&
              pageView !== pageViews.CONTROLLER &&
              pageView !== pageViews.BRAND &&
              (pageView !== pageViews.CREATEYOURRUG ||
                (pageView === pageViews.CREATEYOURRUG &&
                  sessionStorage.getItem("page") === "tamariancustom")) && (
                <Thumbnail
                  thumbType="MY_ROOM"
                  datatitle={strings.myRoom.myRoom}
                  active={visualizationState.viewMode === visViewModes.MY_ROOM}
                  thumb={{ name: strings.myRoom.myRoom, thumbUrl: myroomThumbUrl }}
                  aspect="landscape"
                  onThumbnailClick={handleLoadMyRoom}
                />
              )}
            {myroomState.savedRooms.map((savedRoom, i) => (
              <Thumbnail
                key={i}
                active={visualizationState.viewMode === visViewModes.ROOM_VIEW}
                thumb={savedRoom}
                aspect="landscape"
                onThumbnailClick={() => handleMyRoomThumbnailClick(savedRoom)}
              />
            ))}
          </div>
        </Collapse>
      </div>
      {window.flags.catalogViews && window.flags.catalogViews.length && (
        <>
          <CollapsibleSectionHeading
            title={"Catalog Views"}
            isOpen={!isCollapsed}
            handleCollapseIconClick={() => setIsCollapsed(!isCollapsed)}
            handleHeadingClick={() => setIsCollapsed(!isCollapsed)}
          />
          <div className="at-section-container at-vis-thumbs">
            <div className="thumb-container">
              {window.flags.catalogViews.map(item => (
                <Thumbnail
                  thumbType="ROOM_THUMBS"
                  thumb={item}
                  active={visualizationState.viewMode === visViewModes.CATALOG_VIEW}
                  aspect="landscape"
                  onThumbnailClick={e => {
                    dispatch({ type: visualizationsActions.SET_ACTIVE_NODE, payload: item });
                    dispatch({
                      type: visualizationsActions.SET_VIEW_MODE,
                      payload: visViewModes.CATALOG_VIEW
                    });
                  }}
                />
              ))}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default RoomList;
